<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="searchForm"
               label-width="110px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch">
        <div class="re-el-form__flex">
          <el-form-item label="用户ID"
                        prop="userid">
            <el-input v-model="search.userid"
                      placeholder="请输入用户ID"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="search.status"
                       clearable>
              <el-option v-for="item in tinyStatusMap"
                         :key="item.key"
                         :label="item.value"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh"></el-button>
      </template>
      <div class="margin b15" style="display: flex; justify-content: space-between;">
        <el-button type="primary"
                   size="small"
                   v-if="$route.params.type !== '3'"
                   @click="batchConfirm">批量确认
        </el-button>
        <el-button type="success"
                   size="small"
                   v-if="$route.params.type !== '3'"
                   @click="allConfirm">一键确认
        </el-button>
      </div>
      <el-table :data="table"
                ref="table"
                stripe
                highlight-current-row
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55"></el-table-column>
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="realname"
                         label="姓名"></el-table-column>
        <el-table-column prop="credit"
                         label="提现金额"></el-table-column>
        <el-table-column prop="updatetime"
                         label="提现时间"></el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <span>{{status_map[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fail_reason"
                         label="退回原因">
          <template slot-scope="scope">
            <span>{{handleFailReason(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="140">
          <template slot-scope="scope">
            <div class="button-gutter">
              <button-gutter>
                <el-button size="mini"
                           v-if="scope.row.status * 1 === 2 && $route.params.type !== '3'"
                           @click="onConfirm(scope.row)"
                           type="primary">确定
                </el-button>
                <el-button type="danger"
                           v-if="scope.row.status * 1 === 2 && $route.params.type !== '3'"
                           size="mini"
                           @click="onRollBack(scope.row)">回滚
                </el-button>
              </button-gutter>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      id: this.$route.params.id,
      previousSelected: [],
      selected: [],
      search: {
        userid: this.$route.query.userid || null,
        status: this.$route.query.status * 1 || null,
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 200,
        total: 0,
      },
      withdrawtype: '2,3',
      status_map: {
        '0': '入账',
        '1': '提现处理中',
        '2': '财务处理中',
        '3': '提现操作完成',
        '4': '提现操作被驳回',
        '5': '退回赏金',
        '80': '购物消费',
        '81': '消费退款',
        '82': '交易冲正',
        '99': '兑换',
        // map: [
        //   {key: 0, value: '入账'},
        //   {key: 1, value: '提现处理中'},
        //   {key: 2, value: '财务处理中'},
        //   {key: 3, value: '提现操作完成'},
        //   {key: 4, value: '提现操作被驳回'},
        //   {key: 5, value: '退回赏金'},
        //   {key: 80, value: '购物消费'},
        //   {key: 81, value: '消费退款'},
        //   {key: 82, value: '交易冲正'},
        //   {key: 99, value: '兑换'},
        // ],
      },
      tinyStatusMap: [
        {key: 2, value: '财务处理中'},
        {key: 3, value: '提现操作完成'},
        {key: 4, value: '提现操作被驳回'},
        {key: 5, value: '退回赏金'},
      ]
    }
  },
  created () {

  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      this.previousSelected = this.selected
      this.$refs.table.clearSelection()
      params.id = this.id
      return request.page('batchWithdrawBatchDetailByUser', params)
    },
    /**
     * 重载 设置表格数据
     * @param {*} params
     */
    setTableData ({data}) {
      this.$set(this, 'table', data.data)
      this.setPagination(data)
      this.$nextTick(() => {
        let selected = []
        this.table.forEach((row) => {
          if (this.previousSelected.includes(row.id)) {
            selected.push(row.id)
            this.$refs.table.toggleRowSelection(row, true)
          }
        })
        this.selected = selected
      })
    },
    handleSelectionChange (val) {
      let selected = []
      val.forEach((row) => {
        selected.push(row.id)
      })
      this.selected = selected
    },
    batchConfirm () {
      if (this.selected.length === 0) {
        this.$message.error('请先选择')
        return
      }
      this.$confirm('是否批量确认已勾选内容？', '提示', {type: 'warning'}).then(() => {
        this.batchConfirmRequest()
      }).catch(() => {
        this.$message.info('已取消批量确认')
      })
    },
    batchConfirmRequest () {
      if (this.search.status === 3) { // 欲确认已确认的单子
        this.$message.error('您无法确认已经确认的单子')
        return
      }
      if (this.search.status === 4) { // 欲确认已回滚的单子
        this.$message.error('您无法确认已经回滚的单子')
        return
      }
      let params = {
        id: this.id,
        uids: this.selected,
        ...this.search,
      }
      request.common('batchWithdrawBatchConfirm', params).then((data) => {
        this.$message({
          showClose: true,
          message: '批量确认成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    allConfirm () {
      this.$confirm('是否一键确认全部内容？', '提示', {type: 'warning'}).then(() => {
        this.oneKeyConfirmRequest()
      })
    },
    onConfirm (row) {
      if (!this.checkRowStatus(row)) {
        return
      }
      this.$confirm('是否操作确认？', '提示', {type: 'warning'}).then(() => {
        this.confirmRequest(row)
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    onRollBack (row) {
      if (!this.checkRowStatus(row, '回滚')) {
        return
      }
      this.$prompt('请输入回滚原因', '提示', {
        inputPattern: /\S+/,
        inputErrorMessage: '请输入内容',
      }).then(({value}) => {
        this.rollbackRequest(row, value)
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    handleFailReason (row) {
      if (row.status * 1 !== 5) {
        return ''
      }
      return row.desc.replace(/赏金已退回\|/, '')
    },
    batchRollback () {
      if (this.selected.length === 0) {
        this.$message.error('请先选择')
        return
      }
      if (this.search.status === 3) { // 欲回滚已确认的单子
        this.$message.error('您无法回滚已经确认的单子')
        return
      }
      if (this.search.status === 4) { // 欲回滚已回滚的单子
        this.$message.error('您无法回滚已经回滚的单子')
        return
      }
      let params = {
        id: this.id,
        uids: this.selected,
        ...this.search,
      }
      request.common('batchWithdrawBatchRollback', params).then((data) => {
        this.$message({
          showClose: true,
          message: '批量回滚成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    checkRowStatus (row, action = '确认') {
      if (row.status * 1 !== 2) {
        this.$message.error('您无法' + action + '此单子')
        return false
      }
      return true
    },
    confirmRequest (row) {
      let params = {
        id: this.id,
        uids: row.id,
        ...this.search,
      }
      request.common('batchWithdrawBatchConfirm', params).then((data) => {
        this.$message({
          showClose: true,
          message: '确认成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    rollbackRequest (row, failReason) {
      let params = {
        id: this.id,
        uids: row.id,
        fail_reason: failReason,
        ...this.search,
      }
      request.common('batchWithdrawBatchRollback', params).then((data) => {
        this.$message({
          showClose: true,
          message: '回滚成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    oneKeyConfirmRequest () {
      const params = {
        id: this.id,
        status: 2,
        userid: this.search.userid,
        per_page: this.$route.query.per_page || this.pagination.per_page,
      }
      request.loading('batchWithdrawBatchDetailByUser', params).then(async ({data}) => {
        if (data.data.length > 0) {
          let uidLists = []
          data.data.forEach(item => {
            uidLists.push(item.id)
          })
          const postParams = {
            id: this.id,
            uids: uidLists,
            status: 2,
            userid: this.search.userid,
          }
          await request.loading('batchWithdrawBatchConfirm', postParams).then((data) => {})

          await this.oneKeyConfirmRequest()
        } else {
          this.$message({
            showClose: true,
            message: '一键确认成功',
            type: 'success',
          })
          this.onRefresh()
        }
      })
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance/pages/WithdrawBatchDetail.vue